<template>
  <v-container>
    

    <div class="nmt-1">
      <WorkSheet></WorkSheet>
    </div>
  </v-container>
</template>

<script>

import WorkSheet from "../../../components/StudentPanel/WorkSheet/workSheet";
// components/StudentPanel/WorkSheet/workSheet
export default {
  name: "StudentWorkSheet",
  components: { WorkSheet, },
  data() {
    return {
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>